import { defineComponent as _defineComponent } from 'vue'
import { CommunityTalkStore, isValidCommunityTalkStoreKey } from "@/store/communityTalk/communityTalkStore";
import { inject } from "vue";

interface Props {
	/**
	 * 「追加表示ボタン内部」文言。
	 */
	moreButtonDisplayName: string;
	/**
	 * APIから取得したトークルーム数。
	 */
	talkRoomCurrentDisplayCount: number;
	/**
	 * トークルーム総件数。
	 */
	talkRoomCount: number;
	/**
	 * トークルーム情報を追加している途中かどうか。
	 */
	isProcessingAddTalkRoom: boolean;

	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
}
interface Emits {
	(e: "click-more-button"): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    moreButtonDisplayName: { type: String, required: true },
    talkRoomCurrentDisplayCount: { type: Number, required: true },
    talkRoomCount: { type: Number, required: true },
    isProcessingAddTalkRoom: { type: Boolean, required: true },
    communityTalkStoreKey: { type: String, required: true }
  },
  emits: ["click-more-button"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "click-more-button"): void;
}), expose: any, slots: any, attrs: any }) {
  expose()

const props = __props as {
	/**
	 * 「追加表示ボタン内部」文言。
	 */
	moreButtonDisplayName: string;
	/**
	 * APIから取得したトークルーム数。
	 */
	talkRoomCurrentDisplayCount: number;
	/**
	 * トークルーム総件数。
	 */
	talkRoomCount: number;
	/**
	 * トークルーム情報を追加している途中かどうか。
	 */
	isProcessingAddTalkRoom: boolean;

	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
}
/**
 * トークルーム追加表示ボタン。
 */



// Storeの初期化処理
if (!isValidCommunityTalkStoreKey(props.communityTalkStoreKey)) {
	// なんらかの原因でInjectKeyにエラーが発生していた場合は強制終了
	throw new Error(`InjectKeyにエラーが発生しました。${props.communityTalkStoreKey.toString()}`);
}
const communityTalkStore = inject(props.communityTalkStoreKey) as CommunityTalkStore;

/**
 * トークルームのもっと見るボタンを表示するかどうか。
 */
const isShow = (): boolean => {
	// トークルーム単体表示の場合は表示しない
	const displayTalkRoomId = communityTalkStore.getDisplayTalkRoomId();
	if (displayTalkRoomId != null && displayTalkRoomId !== "") {
		return false;
	}

	// APIから取得したトークルーム数がトークルーム総件数より少ない場合は表示する
	if (props.talkRoomCount > props.talkRoomCurrentDisplayCount) {
		return true;
	}

	return false;
};


const onclick = (): void => {
	emit("click-more-button");
};

const __returned__ = { props, communityTalkStore, isShow, emit, onclick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})